<script setup>
import { useAppConfig } from "@/js/composables/useAppConfig";

const {config} = useAppConfig()
const {urls,isLoggedIn} = config;
</script>

<template>
    <template v-if="isLoggedIn">
        <ul class="drawer_menu-nav">
            <li>
                <a :href="urls.ppcNews" class="drawer_menu-nav-news">PAWASPI NEWS</a>
            </li>
            <li>
                <a :href="urls.ppcCampaign"  class="drawer_menu-nav-campaign">キャンペーン</a>
            </li>
            <li>
                <a :href="urls.ppcItemList" class="drawer_menu-nav-use">つかう</a>
            </li>
            <li>
                <a :href="urls.ppcMissionCategory" class="drawer_menu-nav-save">ためる</a>
            </li>
            <li>
                <a :href="urls.ppcMemberPointBalance" class="drawer_menu-nav-balance">残高</a>
            </li>
            <li>
                <a :href="urls.ppcMemberSetting" class="drawer_menu-nav-setting">マイページ</a>
            </li>
            <li>
                <a :href="urls.ppcTop" class="drawer_menu-nav-top">TOP</a>
            </li>
        </ul>
        <p class="drawer_menu-logout">
            <a :href="urls.logoutUrl">ログアウト</a>
        </p>
    </template>
    <ul class="drawer_menu-nav" v-else>
        <li>
            <a :href="urls.ppcTop" class="drawer_menu-nav-top">TOP</a>
        </li>
        <li>
            <a :href="urls.ppcNews" class="drawer_menu-nav-news">PAWASPI NEWS</a>
        </li>
        <li>
            <a :href="urls.ppcCampaign"  class="drawer_menu-nav-campaign">キャンペーン</a>
        </li>
        <li>
            <a :href="urls.ppcPublicList" class="drawer_menu-nav-use">交換アイテム</a>
        </li>
    </ul>
</template>

<style scoped>

</style>
